/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Video_Export_Preset_Default_NameInputs */

const en_video_export_preset_default_name = /** @type {(inputs: Video_Export_Preset_Default_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Untitled`)
};

const fr_video_export_preset_default_name = /** @type {(inputs: Video_Export_Preset_Default_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sans titre`)
};

const de_video_export_preset_default_name = /** @type {(inputs: Video_Export_Preset_Default_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ohne Titel`)
};

const it_video_export_preset_default_name = /** @type {(inputs: Video_Export_Preset_Default_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Senza titolo`)
};

const ru_video_export_preset_default_name = /** @type {(inputs: Video_Export_Preset_Default_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Без названия`)
};

const es_video_export_preset_default_name = /** @type {(inputs: Video_Export_Preset_Default_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Intitulado`)
};

const zh_cn2_video_export_preset_default_name = /** @type {(inputs: Video_Export_Preset_Default_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`无题`)
};

const ja_video_export_preset_default_name = /** @type {(inputs: Video_Export_Preset_Default_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`無題`)
};

const hi_video_export_preset_default_name = /** @type {(inputs: Video_Export_Preset_Default_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`शीर्षकहीन`)
};

const pt_pt2_video_export_preset_default_name = /** @type {(inputs: Video_Export_Preset_Default_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sem título`)
};

/**
* | output |
* | --- |
* | "Untitled" |
*
* @param {Video_Export_Preset_Default_NameInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const video_export_preset_default_name = /** @type {((inputs?: Video_Export_Preset_Default_NameInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Video_Export_Preset_Default_NameInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_video_export_preset_default_name(inputs)
	if (locale === "de") return de_video_export_preset_default_name(inputs)
	if (locale === "it") return it_video_export_preset_default_name(inputs)
	if (locale === "ru") return ru_video_export_preset_default_name(inputs)
	if (locale === "es") return es_video_export_preset_default_name(inputs)
	if (locale === "zh-CN") return zh_cn2_video_export_preset_default_name(inputs)
	if (locale === "ja") return ja_video_export_preset_default_name(inputs)
	if (locale === "hi") return hi_video_export_preset_default_name(inputs)
	if (locale === "pt-PT") return pt_pt2_video_export_preset_default_name(inputs)
	return en_video_export_preset_default_name(inputs)
});